export const LOCKABLE_RESOURCE_TYPE = {
  LESSON: "lesson",
  LESSON_ACTIVITY: "lessonactivity",
  MEDIAOBJECT: "mediaobject",
  CONTENTMAP: "contentmap",
  SUBJECTGROUP: "subjectgroup",
  MYGROUP: "mygroup",
  NOTIFICATION: "notification",
  STUDENTGROUP: "studentgroup",

  // used for team attempt lock
  QUIZ_ACTIVITY: "quizactivity",
  QUESTION: "question",

  // used for conversation
  TOPIC: "topic",
};

export const LESSON_LOCK_CHANNEL = "lesson-lock";
export const LESSON_LOCK_TAKEN_OVER = "taken-over";
